/*
  Dress the Shopify Forms newsletter pop-up in the house style.

  Shopify Forms draws its form inside a shadow root, so neither btf-theme.css nor the theme's
  type reaches it, and its own font list has neither BW Stretch nor Archivo. This puts a small
  stylesheet inside that shadow root: square corners, Archivo for the text, the heading in
  BW Stretch (upper and lowercase, Duncan, 12 Oct 2026), a 2px ink field border and the button
  label centred in white (Duncan, 12 Oct 2026). The fonts themselves are already declared on
  every page by btf-head.

  Shopify Forms has no supported styling hooks, so this aims at plain elements (h2, input,
  button) rather than its generated class names. If Shopify changes the form, the worst case is
  that it falls back to its own look. Exits at once on a page without the form.
*/
(function () {
  var ID = 'btf-forms-style';
  var CSS =
    '*{border-radius:0!important;font-family:"Archivo",system-ui,sans-serif!important}' +
    'h2{font-family:"BW Stretch","Archivo",sans-serif!important;font-weight:900!important;' +
    'letter-spacing:-0.01em!important;line-height:1.05!important;font-size:28px!important}' +
    'input{border-width:2px!important;border-color:#1d1d1b!important}' +
    'button[type=submit]{text-align:center!important;justify-content:center!important;' +
    'color:#fff!important;text-transform:uppercase!important;letter-spacing:.06em!important;' +
    'font-weight:700!important}button[type=submit] *{color:#fff!important}';

  function dress(host) {
    var root = host.shadowRoot;
    if (!root) return false;
    if (!root.getElementById(ID)) {
      var style = document.createElement('style');
      style.id = ID;
      style.textContent = CSS;
      root.appendChild(style);
    }
    // The form may re-render and drop the sheet, so keep watching its root.
    if (!host.dataset.btfDressed) {
      host.dataset.btfDressed = '1';
      new MutationObserver(function () {
        if (!root.getElementById(ID)) dress(host);
      }).observe(root, { childList: true });
    }
    return true;
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      if (!dress(host)) setTimeout(function () { dress(host); }, 500);
    });
  }

  // The embed arrives after the page, from the app's own script. Look once a frame at most,
  // and stop looking after 20 seconds: by then the app has added its form or never will.
  var queued = false;
  var watch = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  });
  watch.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { watch.disconnect(); }, 20000);
  scan();
})();
